package org.hs_soft.runmynesto.domain.model.home.closing_reports

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings


enum class FinalReportsGroupEnum(
    private val titleKey: String,
    val value: String?
) {
    IN_TOTAL(
        titleKey = "inTotal",
        value = null
    ),
    GROUP_BY_DATE(
        titleKey = "groupByDate",
        value = "date"
    ),
    GROUP_BY_SHOP(
        titleKey = "groupByShop",
        value = "shop"
    ),
    GROUP_BY_DATE_SHOP(
        titleKey = "groupByDateShop",
        value = "dateShop"
    );

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            IN_TOTAL -> strings.inTotal
            GROUP_BY_DATE -> strings.groupByDate
            GROUP_BY_SHOP -> strings.groupByShop
            GROUP_BY_DATE_SHOP -> strings.groupByDateShop
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                IN_TOTAL -> strings.inTotal
                GROUP_BY_DATE -> strings.groupByDate
                GROUP_BY_SHOP -> strings.groupByShop
                GROUP_BY_DATE_SHOP -> strings.groupByDateShop
            }
        }
}